(function () {
  if (window.customElements && customElements.get('guided-navigator')) return;

  function fireEvents(el) {
    ['input', 'change'].forEach(function (t) {
      try { el.dispatchEvent(new Event(t, { bubbles: true })); } catch (e) {}
    });
  }

  // Floating-label forms (Shopify lead capture) pin the label with an inline
  // top while resting; that overrides the "filled" styling, so clear it after fill.
  function clearPinnedLabel(input) {
    function go() {
      try {
        var root = input.getRootNode();
        var lab = null;
        var lb = input.getAttribute('aria-labelledby');
        if (lb) lab = (root.getElementById ? root.getElementById(lb) : null) || root.querySelector('[id="' + lb + '"]');
        if (!lab) lab = input.closest('label');
        if (lab && lab.style) lab.style.removeProperty('top');
      } catch (e) {}
    }
    go();
    setTimeout(go, 120);
    setTimeout(go, 350);
  }

  // Clear pinned labels on every already-filled field — handles browser autofill,
  // password managers, and Shopify's own customer prefill, not just our fields.
  function fixFilledLabels(stepEl) {
    var roots = searchRoots(stepEl);
    for (var i = 0; i < roots.length; i++) {
      var fields = roots[i].querySelectorAll('input, textarea');
      for (var j = 0; j < fields.length; j++) {
        var f = fields[j];
        if (f.matches('[data-carry]')) continue;
        var t = (f.type || '').toLowerCase();
        if (t === 'hidden' || t === 'checkbox' || t === 'radio' || t === 'submit' || t === 'button') continue;
        if (f.value && f.value.trim()) clearPinnedLabel(f);
      }
    }
  }

  // Set the value through the native setter so framework-controlled
  // inputs (React/Preact, like Shopify Forms) register the change, and
  // wrap it in a real focus/blur so floating-label styling flips to "filled".
  function setNativeValue(el, val) {
    try { el.focus({ preventScroll: true }); } catch (e) {}
    try {
      var proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
      var desc = Object.getOwnPropertyDescriptor(proto, 'value');
      if (desc && desc.set) desc.set.call(el, val); else el.value = val;
    } catch (e) { el.value = val; }
    fireEvents(el);
    try { el.blur(); } catch (e) {}
    clearPinnedLabel(el);
  }

  // Shopify Forms draws everything inside each embed's shadow root, so the
  // theme's CSS can't reach it, and its own sheet hard-codes `border: none` and
  // `box-shadow: none` on the button, so its CSS variables can't give it the
  // site's border or drop shadow either. Adopting a sheet into each shadow root
  // is the only way in. Selectors use the data-testid hooks, not the hashed
  // class names, which change with every Forms release.
  function svgUrl(svg) {
    return 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
  }
  var MAIL_ICON = svgUrl(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#564844" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<rect x="3" y="5.5" width="18" height="13" rx="2.5"/><path d="M3.8 7.2 12 13l8.2-5.8"/></svg>'
  );
  var CHECK_ICON = svgUrl(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#6b8a4e" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M6.5 12.5 10 16l7.5-8"/></svg>'
  );
  var SUBMIT = 'form button[type="submit"][data-testid="btn-form-submit"]';
  var SUCCESS = 'section[data-testid="banner-success"]';
  // The "Support path" field, a single-line customer metafield
  // (custom.support_path) added to each support form in the Forms app.
  var PATH_FIELD = 'input[data-testid="field-custom#support_path"]';
  var FORM_CSS =
    // Submit button: the house green CTA — see .cta-headline__btn in
    // assets/section-cta-headline.css. Specific enough to beat the hashed class.
    SUBMIT + ' {' +
    '  padding: 14px 24px;' +
    '  background-color: #cbeaa6;' +
    '  color: #564844;' +
    '  border: 2px solid #aecb8c;' +
    '  border-radius: 50px;' +
    '  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.25);' +
    '  font-size: 16px;' +
    '  font-weight: 700;' +
    '  line-height: 1.375;' +
    '  letter-spacing: 0.04em;' +
    '  filter: none;' +
    '  transition: opacity 0.15s ease, transform 0.1s ease, box-shadow 0.1s ease;' +
    '}' +
    SUBMIT + ':hover,' + SUBMIT + ':focus-visible {' +
    '  border: 2px solid #aecb8c;' +
    '  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.25);' +
    '  filter: none;' +
    '}' +
    '@media (hover: hover) {' +
    '  ' + SUBMIT + ':hover { opacity: 0.88; }' +
    '}' +
    SUBMIT + ':active {' +
    '  transform: translateY(2px);' +
    '  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);' +
    '}' +

    // Success message: an envelope in a cream disc pops in, a check badge
    // stamps onto its corner, then the heading and text rise in. Green is kept
    // for the tick alone. Pseudo-
    // elements rather than injected markup, because the banner is rendered by
    // Preact and nodes added to its tree get thrown away on the next render.
    // Disc colours come from the section's option hover/border settings, which
    // inherit through the shadow boundary.
    SUCCESS + ' { position: relative; }' +
    SUCCESS + '::before {' +
    '  content: "";' +
    '  display: block;' +
    '  box-sizing: border-box;' +
    '  width: 72px;' +
    '  height: 72px;' +
    '  margin: 4px auto 18px;' +
    '  border: 2px solid var(--gn-option-border, #e6ddd6);' +
    '  border-radius: 50%;' +
    '  background: ' + MAIL_ICON + ' center / 36px no-repeat var(--gn-option-hover-bg, #f6efe9);' +
    '  animation: fc-mail-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;' +
    '}' +
    SUCCESS + '::after {' +
    '  content: "";' +
    '  position: absolute;' +
    '  top: 52px;' +
    '  left: calc(50% + 14px);' +
    '  box-sizing: border-box;' +
    '  width: 28px;' +
    '  height: 28px;' +
    '  border: 2px solid var(--gn-option-border, #e6ddd6);' +
    '  border-radius: 50%;' +
    '  background: ' + CHECK_ICON + ' center / 16px no-repeat #fff;' +
    '  animation: fc-mail-check 0.45s 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;' +
    '}' +
    SUCCESS + ' > * { animation: fc-mail-rise 0.4s 0.55s ease-out both; }' +
    '@keyframes fc-mail-pop {' +
    '  from { opacity: 0; transform: translateY(10px) scale(0.6); }' +
    '  to { opacity: 1; transform: none; }' +
    '}' +
    '@keyframes fc-mail-check {' +
    '  from { opacity: 0; transform: scale(0) rotate(-90deg); }' +
    '  to { opacity: 1; transform: none; }' +
    '}' +
    '@keyframes fc-mail-rise {' +
    '  from { opacity: 0; transform: translateY(6px); }' +
    '  to { opacity: 1; transform: none; }' +
    '}' +
    '@media (prefers-reduced-motion: reduce) {' +
    '  ' + SUCCESS + '::before,' + SUCCESS + '::after,' + SUCCESS + ' > * { animation: none; }' +
    '}' +

    // Support path: a field on each support form that the navigator fills
    // with the options the customer clicked, so the ticket says why they
    // wrote in. It is for our team, not the customer, so its whole field
    // (label included) is hidden. Hiding it from this sheet rather than from
    // script means it never flashes on screen while the form hydrates.
    'div:has(> ' + PATH_FIELD + ') { display: none !important; }';
  var formSheet = null;

  // Returns true once every embed under `root` has its shadow root and the sheet.
  function styleForms(root) {
    var embeds = root.querySelectorAll('shopify-forms-embed');
    var done = true;
    for (var i = 0; i < embeds.length; i++) {
      var sr = embeds[i].shadowRoot;
      if (!sr) { done = false; continue; }
      try {
        if (!formSheet) {
          formSheet = new CSSStyleSheet();
          formSheet.replaceSync(FORM_CSS);
        }
        // Checked every time rather than flagged once: if Forms ever reassigns
        // adoptedStyleSheets on a re-render, the next call puts ours back.
        if (sr.adoptedStyleSheets.indexOf(formSheet) === -1) {
          sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat(formSheet);
        }
      } catch (e) {
        if (!sr.querySelector('style[data-fc-form]')) {
          var style = document.createElement('style');
          style.setAttribute('data-fc-form', '');
          style.textContent = FORM_CSS;
          sr.appendChild(style);
        }
      }
    }
    return done;
  }

  // The step plus ALL nested open shadow roots within it (recursive),
  // since Shopify Forms can nest inputs in a shadow tree inside another.
  function searchRoots(stepEl) {
    var roots = [];
    function walk(root) {
      roots.push(root);
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        if (all[i].shadowRoot) walk(all[i].shadowRoot);
      }
    }
    walk(stepEl);
    return roots;
  }

  // Build a best-guess "accessible name" for a field from everywhere a label can live,
  // since Shopify Forms renders bare text inputs with no name/placeholder/aria.
  function fieldName(input, root) {
    var parts = [];
    function push(s) { if (s) parts.push(s); }

    push(input.getAttribute('aria-label'));

    var lb = input.getAttribute('aria-labelledby');
    if (lb) {
      lb.split(/\s+/).forEach(function (id) {
        var e = (root.getElementById && root.getElementById(id)) || document.getElementById(id);
        if (e) push(e.textContent);
      });
    }

    if (input.id) {
      try {
        var safe = (window.CSS && CSS.escape) ? CSS.escape(input.id) : input.id;
        var lf = root.querySelector('label[for="' + safe + '"]');
        if (lf) push(lf.textContent);
      } catch (e) {}
    }

    var ancestorLabel = input.closest('label');
    if (ancestorLabel) push(ancestorLabel.textContent);

    // Climb to the field's container and use its label, even if it's a wrapper grandparent.
    var node = input.parentElement;
    for (var up = 0; up < 5 && node; up++) {
      var labs = node.querySelectorAll('label');
      var ins = node.querySelectorAll('input, textarea, select');
      if (labs.length >= 1 && ins.length <= 1) { push(labs[0].textContent); break; }
      node = node.parentElement;
    }

    push(input.name);
    push(input.placeholder);

    return parts.join(' ').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function findField(stepEl, regex, typePref) {
    var roots = searchRoots(stepEl);

    if (typePref) {
      for (var i = 0; i < roots.length; i++) {
        var pref = roots[i].querySelector('input[type="' + typePref + '"]:not([data-carry])');
        if (pref) return pref;
      }
    }

    for (var r = 0; r < roots.length; r++) {
      var fields = roots[r].querySelectorAll('input, textarea');
      for (var j = 0; j < fields.length; j++) {
        var f = fields[j];
        if (f.matches('[data-carry]')) continue;
        var t = (f.type || '').toLowerCase();
        if (t === 'hidden' || t === 'submit' || t === 'button' || t === 'checkbox' || t === 'radio') continue;
        if (/captcha/i.test(f.name || '')) continue;
        if (regex.test(fieldName(f, roots[r]))) return f;
      }
    }
    return null;
  }

  class GuidedNavigator extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this._onSubmit = this._onSubmit.bind(this);
      this._onBack = this._onBack.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
      this._onFieldEvent = this._onFieldEvent.bind(this);

      this.history = [];
      // The label of the option that led to each step, kept in step with
      // `history`, so the support forms can say which way the customer came.
      this.trail = [];
      this.backBtn = this.querySelector('.guided-nav__back');

      this.addEventListener('click', this._onClick);
      this.addEventListener('submit', this._onSubmit);
      this.addEventListener('input', this._onFieldEvent);
      this.addEventListener('focusout', this._onFieldEvent);
      if (this.backBtn) this.backBtn.addEventListener('click', this._onBack);
      document.addEventListener('shopify:block:select', this._onBlockSelect);

      this._init();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      this.removeEventListener('input', this._onFieldEvent);
      this.removeEventListener('focusout', this._onFieldEvent);
      if (this._loaderTimer) clearInterval(this._loaderTimer);
      if (this._formTimer) clearInterval(this._formTimer);
    }

    // The Forms app script loads after this one and attaches each embed's
    // shadow root when it gets there, so poll until all of them are styled.
    _watchForms() {
      var self = this;
      if (styleForms(this)) return;
      var tries = 0;
      if (this._formTimer) clearInterval(this._formTimer);
      this._formTimer = setInterval(function () {
        if (styleForms(self) || ++tries > 60) {
          clearInterval(self._formTimer);
          self._formTimer = null;
        }
      }, 250);
    }

    get steps() {
      return Array.from(this.querySelectorAll('.guided-nav__step'));
    }

    _byId(id) {
      return this.steps.filter(function (s) { return s.dataset.guidedStep === id; })[0] || null;
    }

    _current() {
      return this.steps.filter(function (s) { return s.classList.contains('is-active'); })[0] || null;
    }

    _store() {
      if (this._carry) return this._carry;
      try {
        var s = sessionStorage.getItem('guidedNav:carry');
        if (s) { this._carry = JSON.parse(s); return this._carry; }
      } catch (e) {}
      return null;
    }

    _setStore(obj) {
      this._carry = obj;
      try { sessionStorage.setItem('guidedNav:carry', JSON.stringify(obj)); } catch (e) {}
    }

    _init() {
      this.classList.add('is-ready');
      this.history = [];
      this.trail = [];
      var startId = (this.getAttribute('data-start') || '').trim();
      var start = (startId && this._byId(startId)) || this.steps[0];
      if (start) this._setActive(start);
      this._updateBack();
      this._validate();
      this._watchForms();
    }

    _setActive(stepEl) {
      this.steps.forEach(function (s) { s.classList.remove('is-active'); });
      stepEl.classList.add('is-active');
      this._afterActivate(stepEl);
    }

    _afterActivate(stepEl) {
      var check = stepEl.querySelector('.guided-nav__check');
      if (check) { check.classList.remove('run'); void check.offsetWidth; check.classList.add('run'); }
      if (stepEl.hasAttribute('data-lookup')) this._resetLookup(stepEl);
      this._prefill(stepEl);
      this._fixLabelsSoon(stepEl);
      styleForms(stepEl);
    }

    _fixLabelsSoon(stepEl) {
      fixFilledLabels(stepEl);
      setTimeout(function () { fixFilledLabels(stepEl); }, 400);
      setTimeout(function () { fixFilledLabels(stepEl); }, 1200);
    }

    _onFieldEvent(e) {
      var path = e.composedPath ? e.composedPath() : [e.target];
      var el = path[0];
      if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')) return;
      if (el.matches && el.matches('[data-carry]')) return;
      if (el.value && el.value.trim()) clearPinnedLabel(el);
    }

    _show(stepEl, push) {
      if (!stepEl) return;
      var current = this._current();
      if (current === stepEl) return;
      if (push && current) {
        this.history.push(current.dataset.guidedStep);
        this.trail.push(this._pendingLabel || stepEl.dataset.guidedStep);
      }
      this._pendingLabel = null;
      this._setActive(stepEl);
      this._updateBack();
      this._focusHeading(stepEl);
      this._maybeScroll();
    }

    _onClick(e) {
      var opt = e.target.closest ? e.target.closest('[data-target]') : null;
      if (!opt || !this.contains(opt)) return;
      var target = this._byId(opt.getAttribute('data-target'));
      if (target) {
        e.preventDefault();
        var label = opt.querySelector('.guided-nav__option-label');
        this._pendingLabel = label ? label.textContent.trim() : '';
        this._show(target, true);
      }
    }

    _onSubmit(e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('[data-lookup-form]')) return;
      if (!this.contains(form)) return;
      e.preventDefault();
      var lookupEl = form.closest('[data-lookup]');
      if (!lookupEl) return;
      var store = this._store() || {};
      form.querySelectorAll('[data-carry]').forEach(function (inp) {
        var k = inp.getAttribute('data-carry');
        var v = (inp.value || '').trim();
        if (v) store[k] = v;
      });
      this._setStore(store);
      var btn = form.querySelector('.guided-nav__lookup-btn');
      this._pendingLabel = btn ? btn.textContent.trim() : '';
      this._runLoader(lookupEl);
    }

    _runLoader(lookupEl) {
      var self = this;
      var body = lookupEl.querySelector('[data-lookup-body]');
      var loader = lookupEl.querySelector('[data-lookup-loader]');
      var fill = lookupEl.querySelector('[data-loader-fill]');
      var status = lookupEl.querySelector('[data-loader-status]');
      var msgEl = lookupEl.querySelector('[data-loader-messages]');
      var msgs = msgEl ? (msgEl.textContent || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean) : [];
      if (!msgs.length) msgs = ['Loading…'];
      var afterId = lookupEl.getAttribute('data-lookup-after');
      var dur = (parseFloat(lookupEl.getAttribute('data-lookup-duration')) || 3) * 1000;

      if (body) body.hidden = true;
      if (loader) loader.hidden = false;
      if (status) status.textContent = msgs[0];

      function finish() {
        var t = self._byId(afterId);
        if (t) { self._show(t, true); }
        else { if (body) body.hidden = false; if (loader) loader.hidden = true; }
      }

      var reduce = false;
      try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
      if (reduce) { if (fill) fill.style.width = '100%'; setTimeout(finish, 400); return; }

      var pct = 0;
      var stepMs = Math.max(30, Math.round(dur / 50));
      if (this._loaderTimer) clearInterval(this._loaderTimer);
      this._loaderTimer = setInterval(function () {
        pct += 2; if (pct > 100) pct = 100;
        if (fill) fill.style.width = pct + '%';
        if (status) {
          var idx = Math.min(msgs.length - 1, Math.floor(pct / 100 * msgs.length));
          if (status.textContent !== msgs[idx]) status.textContent = msgs[idx];
        }
        if (pct >= 100) { clearInterval(self._loaderTimer); self._loaderTimer = null; setTimeout(finish, 300); }
      }, stepMs);
    }

    _resetLookup(lookupEl) {
      var body = lookupEl.querySelector('[data-lookup-body]');
      var loader = lookupEl.querySelector('[data-lookup-loader]');
      var fill = lookupEl.querySelector('[data-loader-fill]');
      if (body) body.hidden = false;
      if (loader) loader.hidden = true;
      if (fill) fill.style.width = '0%';
      var store = this._store();
      if (store) {
        lookupEl.querySelectorAll('[data-carry]').forEach(function (inp) {
          var k = inp.getAttribute('data-carry');
          if (store[k] && !inp.value) inp.value = store[k];
        });
      }
    }

    // "Contact support > Inquire about return/refund > Didn't like the
    // taste/texture > ..." — the options clicked to reach this step.
    _path() {
      return this.trail.filter(Boolean).join(' > ');
    }

    // Unlike email and order number, the path is written every time a form
    // step opens: going Back and taking another route changes it.
    _prefillPath(stepEl) {
      var path = this._path();
      if (!path || !stepEl.querySelector('shopify-forms-embed')) return;
      var deadline = Date.now() + 8000;
      function attempt() {
        var field = null;
        var roots = searchRoots(stepEl);
        for (var i = 0; i < roots.length && !field; i++) field = roots[i].querySelector(PATH_FIELD);
        if (field) { if (field.value !== path) setNativeValue(field, path); return; }
        if (Date.now() < deadline) setTimeout(attempt, 250);
      }
      attempt();
    }

    _prefill(stepEl) {
      try { this._prefillPath(stepEl); } catch (e) {}
      var store = this._store();
      if (!store || (!store.email && !store.order_number)) return;

      function findEmail() {
        return findField(stepEl, /e-?mail/i, 'email');
      }
      function findOrder() {
        return findField(stepEl, /order/i, null);
      }

      // The form hydrates asynchronously, so poll for the fields for a few seconds.
      var deadline = Date.now() + 8000;
      function attempt() {
        var pending = false;
        try {
          if (store.email) {
            var em = findEmail();
            if (em) { if (!em.value) setNativeValue(em, store.email); } else { pending = true; }
          }
          if (store.order_number) {
            var ord = findOrder();
            if (ord) { if (!ord.value) setNativeValue(ord, store.order_number); } else { pending = true; }
          }
        } catch (e) {}
        if (pending && Date.now() < deadline) setTimeout(attempt, 250);
      }
      attempt();
    }

    _onBack(e) {
      e.preventDefault();
      if (!this.history.length) return;
      var prev = this._byId(this.history.pop());
      this.trail.pop();
      if (!prev) return;
      this._setActive(prev);
      this._updateBack();
      this._focusHeading(prev);
    }

    _updateBack() {
      if (!this.backBtn) return;
      var allow = this.getAttribute('data-show-back') !== 'false';
      this.backBtn.hidden = !(allow && this.history.length > 0);
    }

    _focusHeading(stepEl) {
      var h = stepEl.querySelector('.guided-nav__heading');
      if (!h) return;
      h.setAttribute('tabindex', '-1');
      try { h.focus({ preventScroll: true }); } catch (err) { h.focus(); }
    }

    _maybeScroll() {
      var r = this.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) {
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    _onBlockSelect(e) {
      if (!this.contains(e.target)) return;
      var step = e.target.closest('.guided-nav__step');
      if (!step) return;
      this._setActive(step);
      this._updateBack();
    }

    _validate() {
      if (!(window.Shopify && window.Shopify.designMode)) return;
      var ids = this.steps.map(function (s) { return s.dataset.guidedStep; });
      this.querySelectorAll('[data-target]').forEach(function (opt) {
        var t = opt.getAttribute('data-target');
        var ok = t && ids.indexOf(t) !== -1;
        opt.classList.toggle('guided-nav__option--broken', !ok);
        if (!ok) opt.setAttribute('title', 'Target step ID not found: "' + (t || '') + '"');
        else opt.removeAttribute('title');
      });
      this.querySelectorAll('[data-lookup]').forEach(function (lk) {
        var t = lk.getAttribute('data-lookup-after');
        var ok = t && ids.indexOf(t) !== -1;
        var btn = lk.querySelector('.guided-nav__lookup-btn');
        if (btn) {
          btn.classList.toggle('guided-nav__option--broken', !ok);
          if (!ok) btn.setAttribute('title', 'Lookup target step not found: "' + (t || '') + '"');
          else btn.removeAttribute('title');
        }
      });
    }
  }

  customElements.define('guided-navigator', GuidedNavigator);
})();